import React from 'react';
import { Layout } from 'antd';

export function AppLayout({ children, ...props }) {
  return (
    <Layout.Content
      style={{
        margin: '16px',
        padding: '8px',
        background: '#fafafa',
        height: '100vh',
      }}
      {...props}
    >
      {children}
    </Layout.Content>
  );
}
